import { render, staticRenderFns } from "./wcMall.vue?vue&type=template&id=56ec1b9c&scoped=true&"
import script from "./wcMall.vue?vue&type=script&lang=js&"
export * from "./wcMall.vue?vue&type=script&lang=js&"
import style0 from "./wcMall.vue?vue&type=style&index=0&id=56ec1b9c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ec1b9c",
  null
  
)

export default component.exports